import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptTurnRevised, {
	type TranscriptTurnRevisedAction,
	type TranscriptTurnRevisedPayload,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptTurnRevised';
import transcriptTurnRevisionFailed, {
	type TranscriptTurnRevisionFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptTurnRevisionFailed';
import type ReviseTranscriptTurn from '@Application/Beneficiaries/Transcripts/Commands/ReviseTranscriptTurn';
import { patch } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptTurnRevisedAction | TranscriptTurnRevisionFailedAction;

export default (command: ReviseTranscriptTurn) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<TranscriptTurnRevisedPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/transcript/turns/${command.turnId}`,
				command.toJSON(),
			);

			const action = transcriptTurnRevised(payload, command.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptTurnRevisionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
